import React, { useCallback, useEffect, useRef, useState } from 'react';
import api from '../api';
import toast from 'react-hot-toast';
import { useSocketEvent } from '../hooks/useSocket';

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ notifications: [], unread: 0 });
  const previousUnread = useRef(null);
  const buttonRef = useRef(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

  const load = useCallback(async () => {
    try {
      const r = await api.get('/admin/notifications');
      if (previousUnread.current !== null && r.data.unread > previousUnread.current) {
        toast(`🔔 ${r.data.notifications[0]?.title || 'New notification'}`);
      }
      previousUnread.current = r.data.unread;
      setData(r.data);
    } catch { /* notifications are best-effort; polling will try again */ }
  }, []);
  useEffect(() => { load(); const id = setInterval(load, 30000); return () => clearInterval(id); }, [load]);
  useSocketEvent('notification:new', load);

  const positionMenu = useCallback(() => {
    const rect = buttonRef.current?.getBoundingClientRect();
    if (!rect) return;
    const width = Math.min(310, window.innerWidth - 24);
    setMenuPosition({
      top: rect.bottom + 8,
      left: Math.min(rect.right + 8, window.innerWidth - width - 12),
    });
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    positionMenu();
    window.addEventListener('resize', positionMenu);
    return () => window.removeEventListener('resize', positionMenu);
  }, [open, positionMenu]);

  const markRead = async (id) => {
    try { await api.patch(`/admin/notifications/${id}/read`); load(); } catch { toast.error('Could not update notification'); }
  };
  const markAll = async () => { try { await api.patch('/admin/notifications/read-all'); load(); } catch {} };

  return <div className="notification-wrap">
    <button ref={buttonRef} className="notification-button" onClick={() => setOpen(v => !v)} aria-label="Notifications" aria-expanded={open}>
      🔔{data.unread > 0 && <span className="notification-badge">{data.unread > 9 ? '9+' : data.unread}</span>}
    </button>
    {open && <div className="notification-menu" style={menuPosition}>
      <div className="notification-head"><strong>Notifications</strong>{data.unread > 0 && <button onClick={markAll}>Mark all read</button>}</div>
      {!data.notifications.length && <div className="notification-empty">No notifications yet</div>}
      {data.notifications.map(n => <button key={n._id} className={`notification-item ${n.readAt ? '' : 'unread'}`} onClick={() => !n.readAt && markRead(n._id)}>
        <strong>{n.title}</strong><span>{n.message}</span><small>{new Date(n.createdAt).toLocaleString()}</small>
      </button>)}
    </div>}
  </div>;
}
